import axios from "axios";

const API_KEY = process.env.REACT_APP_API_KEY;
const URL = process.env.REACT_APP_API_URL;

// In den ausgelieferten Builds zeigt REACT_APP_API_URL auf die Durchreiche der
// Homepage (/api/konfigurator); sie haengt den API-Key serverseitig an. Ein Key
// im Build waere im Bundle fuer jeden lesbar. REACT_APP_API_KEY ist deshalb nur
// noch fuer die lokale Entwicklung direkt gegen das Backend gedacht.
const keyHeader = API_KEY ? { "x-api-key": API_KEY } : {};

export const apiJson = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
    ...keyHeader,
  },
});

export const apiFile = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "multipart/form-data",
    ...keyHeader,
  },
});
